
// import CallingConfig from './calling/CallingConfig';
// import ChatAppConfig from './chat/ChatAppConfig';
import ContactsAppConfig from './contacts/ContactsAppConfig';
import MailAppConfig from './mail/MailAppConfig';

const appsConfigs = [
	MailAppConfig,
	ContactsAppConfig,


];

export default appsConfigs;
